import type { HomeChargingSupportingDocumentStatus } from "@qivia/ui";
import { HomeChargingSupportingDocument } from "./homeChargingSupportingDocumentsAPI";

export const getHomeChargingSupportingDocumentStatus = (
  supportingDocument: HomeChargingSupportingDocument,
  isCurrentMonth: boolean,
): HomeChargingSupportingDocumentStatus =>
  isCurrentMonth
    ? "CURRENT_MONTH"
    : supportingDocument.chargesCount === 0
      ? "NOTHING_TO_CREATE"
      : supportingDocument.supportingDocument
        ? "CREATED"
        : "TO_CREATE";

// Adding drivers or vehicles is processed asynchronously by ev-charging after
// office answers, one item after the other: the list is fetched again once the
// addition is likely done.
const REFRESH_DELAY_PER_ADDED_ITEM_IN_MS = 1_000;
const MAX_REFRESH_DELAY_IN_MS = 10_000;

export const getHomeChargingAdditionRefreshDelay = (addedItemsCount: number) =>
  Math.min(
    Math.max(addedItemsCount, 1) * REFRESH_DELAY_PER_ADDED_ITEM_IN_MS,
    MAX_REFRESH_DELAY_IN_MS,
  );
